/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_Bulk_Transfer_SrealityInputs */

const cs_properties_bulk_transfer_sreality = /** @type {(inputs: Properties_Bulk_Transfer_SrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zařadit reprovision Sreality prodejce`)
};

const en_properties_bulk_transfer_sreality = /** @type {(inputs: Properties_Bulk_Transfer_SrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Sreality seller reprovision`)
};

/**
* | output |
* | --- |
* | "Queue Sreality seller reprovision" |
*
* @param {Properties_Bulk_Transfer_SrealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_transfer_sreality = /** @type {((inputs?: Properties_Bulk_Transfer_SrealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_Transfer_SrealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_transfer_sreality(inputs)
	return cs_properties_bulk_transfer_sreality(inputs)
});